import {Roles, TeamRoles} from '../roles';
import {Actions} from './actions';

export const Permissions: Record<Actions, (Roles | TeamRoles)[]> = {
  [Actions.VIEW_CULTURE_KPI]: [
    Roles.OWNER,
    Roles.ADMIN,
    Roles.MANAGER,
    Roles.MEMBER,
  ],
  [Actions.CREATE_ASSESSMENT]: [Roles.OWNER, Roles.ADMIN],
  [Actions.MODIFY_CULTURE_KPI]: [Roles.OWNER, Roles.ADMIN],
  [Actions.EDIT_MEETING_CLASSIFICATION_SETTINGS]: [Roles.OWNER, Roles.ADMIN],
  [Actions.EDIT_INSTILL_FLOW_SETTINGS]: [Roles.OWNER, Roles.ADMIN],
  [Actions.EDIT_COMPANY]: [Roles.OWNER, Roles.ADMIN],
  [Actions.VIEW_BUSINESS_OUTCOMES]: [Roles.OWNER, Roles.ADMIN],
  [Actions.EDIT_BUSINESS_OUTCOMES]: [Roles.OWNER, Roles.ADMIN],
  [Actions.VIEW_DASHBOARD_STEPS]: [Roles.OWNER, Roles.ADMIN],
  [Actions.ADD_VALUE]: [Roles.OWNER, Roles.ADMIN],
  [Actions.EDIT_VALUE]: [Roles.OWNER, Roles.ADMIN],
  [Actions.DELETE_VALUE]: [Roles.OWNER, Roles.ADMIN],
  [Actions.EDIT_MISSION_VISION_MANIFESTO]: [Roles.OWNER, Roles.ADMIN],
  [Actions.EDIT_ORGANIZATION_STRUCTURE]: [Roles.OWNER, Roles.ADMIN],
  [Actions.EDIT_TEAM]: [Roles.OWNER, Roles.ADMIN, Roles.MANAGER],
  [Actions.ADD_TEAM]: [Roles.OWNER, Roles.ADMIN, Roles.MANAGER],
  [Actions.DELETE_TEAM]: [Roles.OWNER, Roles.ADMIN, Roles.MANAGER],
  [Actions.ADD_EMPLOYEE]: [Roles.OWNER, Roles.ADMIN, Roles.MANAGER],
  [Actions.INVITE_MANAGER]: [Roles.OWNER, Roles.ADMIN, Roles.MANAGER],
  [Actions.INVITE_ADMIN]: [Roles.OWNER, Roles.ADMIN],
  [Actions.INVITE_OWNER]: [],
  [Actions.UPDATE_KUDO_VISIBILITY]: [Roles.OWNER, Roles.ADMIN],
  [Actions.UPDATE_ROLE_TO_ADMIN]: [Roles.OWNER, Roles.ADMIN],
  [Actions.UPDATE_ROLE_TO_MANAGER]: [Roles.OWNER, Roles.ADMIN, Roles.MANAGER],
  [Actions.UPDATE_ROLE_TO_OWNER]: [Roles.OWNER],
  [Actions.UPDATE_ROLE_TO_MEMBER]: [
    Roles.OWNER,
    Roles.ADMIN,
    Roles.MANAGER,
    Roles.MEMBER,
  ],
  [Actions.VIEW_COMPANY_SETTINGS]: [Roles.OWNER, Roles.ADMIN],
  [Actions.VIEW_CANDIDATE_CALIBRATION]: [
    Roles.OWNER,
    Roles.ADMIN,
    Roles.MANAGER,
  ],
  [Actions.VIEW_MANAGE_ASSESSMENTS]: [Roles.OWNER, Roles.ADMIN],
  [Actions.VIEW_MANAGE_DIRECTORY]: [Roles.OWNER, Roles.ADMIN],
  [Actions.VIEW_ACTION_STEP_STATUS]: [Roles.OWNER, Roles.ADMIN],
  [Actions.VIEW_COMPANY_ACTION_STEPS]: [
    Roles.OWNER,
    Roles.ADMIN,
    Roles.MANAGER,
  ],
  [Actions.SLACK_INTEGRATIONS]: [Roles.OWNER, Roles.ADMIN],
  [Actions.UPDATE_PLAN]: [Roles.OWNER, Roles.ADMIN],
  [Actions.VIEW_BILLING]: [Roles.OWNER, Roles.ADMIN],
  // IT-2199: every role manages its own personal integrations (calendars);
  // organization-level integrations are gated separately below.
  [Actions.VIEW_INTEGRATIONS]: [
    Roles.OWNER,
    Roles.ADMIN,
    Roles.MANAGER,
    Roles.MEMBER,
  ],
  // These gate the People list row actions, which are Change Role and
  // Offboard. Both write `role`/`is_active`, and following the 2026-09-22 pen
  // test the API restricts those two fields to administrators — a manager now
  // gets 403. Managers are excluded here so the action is hidden rather than
  // offered and then refused.
  [Actions.PERFORM_PEOPLE_ACTION_ON_OWNER]: [Roles.OWNER],
  [Actions.PERFORM_PEOPLE_ACTION_ON_ADMIN]: [Roles.OWNER, Roles.ADMIN],
  [Actions.PERFORM_PEOPLE_ACTION_ON_MANAGER]: [Roles.OWNER, Roles.ADMIN],
  [Actions.PERFORM_PEOPLE_ACTION_ON_MEMBER]: [Roles.OWNER, Roles.ADMIN],
  [Actions.SEND_TAKEAWAYS_EMAIL]: [Roles.OWNER, Roles.ADMIN, Roles.MANAGER],
  // Personal culture scores are private to the person: only the viewer of
  // their OWN profile passes — owners, admins, and team managers viewing
  // someone else's profile do not. Team/leadership analytics have their own
  // actions; this one is deliberately self-only.
  [Actions.VIEW_USER_CULTURE_CONTRIBUTION]: [TeamRoles.CURRENT_USER],
  [Actions.VIEW_LEADERSHIP_SCORE]: [Roles.OWNER, Roles.ADMIN],
  [Actions.VIEW_MICRO_CULTURE_SCORE]: [Roles.OWNER, Roles.ADMIN],
  [Actions.VIEW_KEY_TRENDS_WIDGET]: [Roles.OWNER, Roles.ADMIN, Roles.MANAGER],
  [Actions.VIEW_COMPANY_KEY_TRENDS]: [Roles.OWNER, Roles.ADMIN],
  [Actions.SEND_VALUES_REMINDER]: [Roles.OWNER, Roles.ADMIN],
  [Actions.PERSONALITY_ASSESSMENT_REMINDER]: [Roles.OWNER, Roles.ADMIN],
  // IT-2196 settings restructure
  [Actions.VIEW_PRIVACY_PREFERENCES]: [
    Roles.OWNER,
    Roles.ADMIN,
    Roles.MANAGER,
    Roles.MEMBER,
  ],
  [Actions.MANAGE_ORGANIZATION_INTEGRATIONS]: [Roles.OWNER, Roles.ADMIN],
};
